import { Button, Typography } from 'antd';
import { useEffect } from 'react';

import logo from 'assets/images/logo.svg';
import maintenance from 'assets/images/maintenance.svg';

import styles from './index.module.scss';

export const Maintenance = () => {
	useEffect(() => {
		document.title = 'Crowdpear: Maintenance';
	}, []);

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<div className={styles.logo}>
					<img src={logo} alt="crowd pear" />
				</div>

				<div className={styles.card}>
					<img src={maintenance} alt="crowd pear" className={styles.maintenance} />
					<Typography.Text className={styles.text}>
						Sorry, we are down for the scheduled maintenance right now but soon will be available
						again.
					</Typography.Text>

					<Button
						type="primary"
						block
						className={styles.retry}
						onClick={() => window.location.reload()}
					>
						Retry
					</Button>
				</div>
			</div>
		</div>
	);
};
